$(window).on('load' ,function() {
	$('.js-background-scale').addClass('zoom-in')
});
